<script setup lang="ts">
const tooltipContent = 'Goalbook discourages entering student personally identifiable information.'
</script>
<template>
  <span
    class="material-icons-round text-primary-400"
    v-tooltip.right="{
      value: tooltipContent, 
      class: 'tooltip-style tooltip-style-z'
    }"
    >help</span
  >
</template>
